import React, { useEffect, useState } from "react";
import * as serviceWorkerRegistration from "./src/serviceWorkerRegistration";
import { NavigationContainer } from "@react-navigation/native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { LoginScreen, HomeScreen } from "./src/screens";
import { Alert, Platform, Pressable, StyleSheet, View } from "react-native";
import { decode, encode } from "base-64";
import NetInfo from "@react-native-community/netinfo";
if (!global.btoa) {
  global.btoa = encode;
}
if (!global.atob) {
  global.atob = decode;
}
import { firebaseApp } from "./src/firebase/config";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { getFirestore, getDoc, doc } from "firebase/firestore";
import { ActivityIndicator, Text } from "react-native";
import { Provider, useDispatch, useSelector } from "react-redux";
import store from "./src/store/index";
import { buildingListActions } from "./src/store/building-slice";
import { connectivityActions } from "./src/store/connectivity-slice";
import BuildingScreen from "./src/screens/BuildingScreen/BuildingScreen";
import CleanScreen from "./src/screens/CleanScreen/CleanScreen";
import AgoraLiveWrapper from "./src/components/AgoraLive";
import CleanAndDropSelectionScreen from "./src/screens/CleanAndDropSelectionScreen/CleanAndDropSelectionScreen";
import BuildingDashboard from "./src/screens/BuildingDashboard";
import WeatherForm from "./src/screens/WeatherForm";
import EquipmentForm from "./src/screens/EquipmentForm";
import WelcomeBackHeader from "./src/components/WelcomeBackHeader";
import DefectReportingFormScreen from "./src/screens/DefectReportingForm/DefectReportingFormScreen";
import ScheduledTasksForm from "./src/screens/ScheduledTasksForm/ScheduledTasksForm";
import SubmitScreen from "./src/screens/SubmitScreen/SubmitScreen";
import ThankYouScreen from "./src/screens/ThankYouScreen/ThankYouScreen";
import ResetPasswordScreen from "./src/screens/ResetPasswordScreen";
import SingleWindowDefectReportScreen from "./src/screens/SingleWindowDefectReportScreen";
import PPEFormScreen from "./src/screens/PPEFormScreen";
import CategoryScreen from "./src/screens/CategoryScreen/CategoryScreen";
import QualityControlScreen from "./src/screens/QualityControlScreen/QualityControlScreen";
import QualityControlWizardForm from "./src/screens/QualityControlWizardForm/QualityControlWizardForm";
import NewAdhocSite from "./src/screens/NewAdhocSite";
import { authActions } from "./src/store/auth-slice";
import { getAccess } from "./src/utils/helpers/roles";
import {
  flushPendingFirestoreWrites,
  getOfflineQueuedWriteCount,
  isDeviceOnline,
} from "./src/utils/offlineWriteQueue";
import {
  flushDeferredMediaUploads,
  getDeferredMediaQueueCount,
} from "./src/utils/deferredMediaQueue";


const INSTALL_BANNER_DISMISSED_AT_KEY = "wcInstallBannerDismissedAt";
const INSTALL_BANNER_SNOOZE_MS = 1000 * 60 * 60 * 24 * 7;

const isLikelyMobileWeb = () => {
  if (typeof navigator === "undefined") {
    return false;
  }

  const ua = navigator.userAgent || "";
  return /Android|iPhone|iPad|iPod|Mobile/i.test(ua);
};

const isRunningStandalone = () => {
  if (typeof window === "undefined") {
    return false;
  }

  const displayStandalone = window.matchMedia?.("(display-mode: standalone)")?.matches;
  const iosStandalone = Boolean(window.navigator?.standalone);
  return Boolean(displayStandalone || iosStandalone);
};

const Stack = createNativeStackNavigator();

const AppWrapper = () => {
  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
};

const App = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [showInstallBanner, setShowInstallBanner] = useState(false);
  const [deferredInstallPrompt, setDeferredInstallPrompt] = useState(null);

  const isAuth = useSelector((state) => state.auth.isAuth);
  const isOnline = useSelector((state) => state.connectivity.isOnline);
  const queuedWriteCount = useSelector((state) => state.connectivity.queuedWriteCount);
  const queuedMediaCount = useSelector((state) => state.connectivity.queuedMediaCount);
  const db = getFirestore(firebaseApp);

  useEffect(() => {
    const auth = getAuth(firebaseApp);

    onAuthStateChanged(auth, async (userF) => {
      if (!userF) {
        setLoading(false);
        return;
      }
      const userRef = doc(db, "UsersX", userF.uid);
      getData(userRef);
    });
  }, []);

  useEffect(() => {
    let isMounted = true;

    const syncConnectivityAndQueue = async () => {
      const online = await isDeviceOnline();
      if (!isMounted) {
        return;
      }

      dispatch(connectivityActions.setOnlineStatus({ isOnline: online }));

      if (online) {
        await flushPendingFirestoreWrites(db);
        await flushDeferredMediaUploads(db);
      }

      const queueCount = await getOfflineQueuedWriteCount();
      const mediaQueueCount = await getDeferredMediaQueueCount();
      if (isMounted) {
        dispatch(connectivityActions.setQueuedWriteCount({ count: queueCount }));
        dispatch(connectivityActions.setQueuedMediaCount({ count: mediaQueueCount }));
      }
    };

    syncConnectivityAndQueue();

    const unsubscribeNetInfo = NetInfo.addEventListener(async (state) => {
      const online = Boolean(
        typeof state?.isInternetReachable === "boolean"
          ? state.isConnected && state.isInternetReachable
          : state?.isConnected
      );

      dispatch(connectivityActions.setOnlineStatus({ isOnline: online }));

      if (online) {
        await flushPendingFirestoreWrites(db);
        await flushDeferredMediaUploads(db);
      }

      const queueCount = await getOfflineQueuedWriteCount();
      const mediaQueueCount = await getDeferredMediaQueueCount();
      dispatch(connectivityActions.setQueuedWriteCount({ count: queueCount }));
      dispatch(connectivityActions.setQueuedMediaCount({ count: mediaQueueCount }));
    });

    const onBrowserOnline = async () => {
      dispatch(connectivityActions.setOnlineStatus({ isOnline: true }));
      await flushPendingFirestoreWrites(db);
      await flushDeferredMediaUploads(db);
      const queueCount = await getOfflineQueuedWriteCount();
      const mediaQueueCount = await getDeferredMediaQueueCount();
      dispatch(connectivityActions.setQueuedWriteCount({ count: queueCount }));
      dispatch(connectivityActions.setQueuedMediaCount({ count: mediaQueueCount }));
    };

    const onBrowserOffline = () => {
      dispatch(connectivityActions.setOnlineStatus({ isOnline: false }));
    };

    if (typeof window !== "undefined" && window.addEventListener) {
      window.addEventListener("online", onBrowserOnline);
      window.addEventListener("offline", onBrowserOffline);
    }

    return () => {
      isMounted = false;
      unsubscribeNetInfo?.();
      if (typeof window !== "undefined" && window.removeEventListener) {
        window.removeEventListener("online", onBrowserOnline);
        window.removeEventListener("offline", onBrowserOffline);
      }
    };
  }, [db, dispatch]);

  useEffect(() => {
    if (Platform.OS !== "web") {
      return undefined;
    }

    let refreshing = false;
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (!refreshing) {
          refreshing = true;
          window.location.reload();
        }
      });
    }

    serviceWorkerRegistration.register({
      onUpdate: (registration) => {
        if (registration && registration.waiting) {
          import("sweetalert2")
            .then((SwalModule) => {
              const Swal = SwalModule.default;
              Swal.fire({
                title: "Update Available!",
                text: "A new version of the app is ready. Would you like to update now?",
                icon: "info",
                showCancelButton: true,
                confirmButtonText: "Update Now",
                cancelButtonText: "Later",
                confirmButtonColor: "#5e99fa",
                cancelButtonColor: "#aaa",
              }).then((result) => {
                if (result.isConfirmed) {
                  registration.waiting.postMessage({ type: "SKIP_WAITING" });
                }
              });
            })
            .catch((err) => {
              console.error("Failed to load sweetalert2", err);
              if (window.confirm("A new version is available. Update now?")) {
                registration.waiting.postMessage({ type: "SKIP_WAITING" });
              }
            });
        }
      },
    });
  }, []);

  useEffect(() => {
    if (Platform.OS !== "web") {
      return undefined;
    }

    if (!isLikelyMobileWeb() || isRunningStandalone()) {
      setShowInstallBanner(false);
      return undefined;
    }

    const dismissedAt = Number(localStorage.getItem(INSTALL_BANNER_DISMISSED_AT_KEY) || 0);
    const shouldRespectSnooze = Date.now() - dismissedAt < INSTALL_BANNER_SNOOZE_MS;

    if (!shouldRespectSnooze) {
      setShowInstallBanner(true);
    }

    const onBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredInstallPrompt(event);
      if (!shouldRespectSnooze) {
        setShowInstallBanner(true);
      }
    };

    const onAppInstalled = () => {
      setDeferredInstallPrompt(null);
      setShowInstallBanner(false);
      localStorage.removeItem(INSTALL_BANNER_DISMISSED_AT_KEY);
    };

    window.addEventListener("beforeinstallprompt", onBeforeInstallPrompt);
    window.addEventListener("appinstalled", onAppInstalled);

    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstallPrompt);
      window.removeEventListener("appinstalled", onAppInstalled);
    };
  }, []);

  const dismissInstallBanner = () => {
    if (Platform.OS === "web") {
      localStorage.setItem(INSTALL_BANNER_DISMISSED_AT_KEY, String(Date.now()));
    }
    setShowInstallBanner(false);
  };

  const handleInstallPress = async () => {
    if (!deferredInstallPrompt) {
      alert("To install: open your browser menu and choose 'Add to Home screen'.");
      return;
    }

    deferredInstallPrompt.prompt();
    const userChoice = await deferredInstallPrompt.userChoice;
    if (userChoice?.outcome !== "accepted") {
      dismissInstallBanner();
    } else {
      setShowInstallBanner(false);
      localStorage.removeItem(INSTALL_BANNER_DISMISSED_AT_KEY);
    }
    setDeferredInstallPrompt(null);
  };

  const getData = async (userRef) => {
    try {
      const res = await getDoc(userRef);

      const userData = res.data();

      if (!res.exists()) {
        throw new Error("No data found for user.");
      }

      if (!getAccess(userData.role)) {
        setLoading(false);
        throw new Error("Oops, you don't have permission to access this app.");
      }

      const data = {
        name: userData.name,
        profile_img: userData.profile_img,
        uid: res.id,
        role: userData.role,
        buildings: userData.access,
      };

      dispatch(authActions.authenticate({ isAuth: true }));

      dispatch(
        authActions.userData({
          name: data.name,
          role: data.role,
          profile_img: data.profile_img,
          uid: data.uid,
        })
      );
      dispatch(
        buildingListActions.buildingsList({ buildings: data.buildings })
      );
      setLoading(false);
    } catch (error) {
      dispatch(authActions.authenticate({ isAuth: false }));
      const auth = getAuth(firebaseApp);
      signOut(auth).then(() => {
        if (Platform.OS === "web") {
          alert(error.message || error);
        } else {
          Alert.alert("Oops", error.message || String(error));
        }
      });
    }
  };

  if (loading) {
    return <ActivityIndicator />;
  }

  const onLogoutPress = () => {
    const auth = getAuth(firebaseApp);
    signOut(auth).then((r) => {
      setUser(null);
      dispatch(authActions.authenticate({ isAuth: false }));
    });
  };

  const BLUE_HEADER_OPTIONS = {
    title: "",
    headerTintColor: "#fff",
    headerStyle: {
      backgroundColor: "#5e99fa",
    },
  };

  return (
    <View style={styles.appContainer}>
      {!isOnline ? (
        <View style={styles.connectivityBannerOffline}>
          <Text style={styles.connectivityBannerText}>
            Offline mode: submissions are queued and will sync when connection returns.
          </Text>
        </View>
      ) : queuedWriteCount > 0 || queuedMediaCount > 0 ? (
        <View style={styles.connectivityBannerSyncing}>
          <Text style={styles.connectivityBannerText}>
            Syncing queued work (forms: {queuedWriteCount}, photos: {queuedMediaCount})...
          </Text>
        </View>
      ) : null}

      {Platform.OS === "web" && isAuth && showInstallBanner && isLikelyMobileWeb() && !isRunningStandalone() ? (
        <View style={styles.installBanner}>
          <Text style={styles.installBannerText}>
            Install this app for faster launch and better offline reliability.
          </Text>
          <View style={styles.installBannerActions}>
            <Pressable onPress={dismissInstallBanner} style={styles.installBannerSecondaryButton}>
              <Text style={styles.installBannerSecondaryText}>Not now</Text>
            </Pressable>
            <Pressable onPress={handleInstallPress} style={styles.installBannerPrimaryButton}>
              <Text style={styles.installBannerPrimaryText}>Install</Text>
            </Pressable>
          </View>
        </View>
      ) : null}

      <NavigationContainer>
        <Stack.Navigator>
        {isAuth ? (
          <>
            <Stack.Screen name="Home" options={{ header: WelcomeBackHeader }}>
              {(props) => <HomeScreen {...props} extraData={user} />}
            </Stack.Screen>

            <Stack.Screen
              name="Building"
              component={BuildingScreen}
              options={BLUE_HEADER_OPTIONS}
            />
            <Stack.Screen
              name="Category"
              component={CategoryScreen}
              options={BLUE_HEADER_OPTIONS}
            />
            <Stack.Screen
              name="QualityControlScreen"
              component={QualityControlScreen}
              options={{ ...BLUE_HEADER_OPTIONS, title: "Quality Control" }}
            />
            <Stack.Screen
              name="QualityControlWizardForm"
              component={QualityControlWizardForm}
              options={{
                ...BLUE_HEADER_OPTIONS,
                title: "Quality Control Form",
              }}
            />
            <Stack.Screen
              name="CleanAndDropSelection"
              component={CleanAndDropSelectionScreen}
              options={BLUE_HEADER_OPTIONS}
            />
            <Stack.Screen name="Dashboard" component={BuildingDashboard} />
            <Stack.Screen
              name="Weather"
              component={WeatherForm}
              options={{ ...BLUE_HEADER_OPTIONS, title: "Weather Form" }}
            />
            <Stack.Screen
              name="Equipment"
              component={EquipmentForm}
              options={{ ...BLUE_HEADER_OPTIONS, title: "Equipment Form" }}
            />
            <Stack.Screen
              name="Defects"
              component={DefectReportingFormScreen}
              options={{
                ...BLUE_HEADER_OPTIONS,
                title: "Defect Reporting Form",
              }}
            />
            <Stack.Screen
              name="SingleWindowDefect"
              component={SingleWindowDefectReportScreen}
              options={{ headerShown: false }}
            />
            <Stack.Screen
              name="Schedules"
              component={ScheduledTasksForm}
              options={{
                ...BLUE_HEADER_OPTIONS,
                title: "Scheduled Tasks Form",
              }}
            />
            <Stack.Screen
              name="PPE"
              component={PPEFormScreen}
              options={{ ...BLUE_HEADER_OPTIONS, title: "PPE Checklist" }}
            />
            <Stack.Screen
              name="Clean"
              component={CleanScreen}
              options={{ headerShown: false }}
            />
            <Stack.Screen
              name="Adhoc"
              component={NewAdhocSite}
              options={{ headerShown: true }}
            />
            <Stack.Screen
              name="LiveStream"
              component={AgoraLiveWrapper}
              options={{ headerShown: true }}
            />
            <Stack.Screen
              name="Submit"
              component={SubmitScreen}
              options={{ headerShown: false }}
            />
            <Stack.Screen
              name="Thanks"
              component={ThankYouScreen}
              options={{ headerShown: false }}
            />
          </>
        ) : (
          <>
            <Stack.Screen
              name="Login"
              component={LoginScreen}
              options={{ headerShown: false }}
            />
            <Stack.Screen
              name="ResetPassword"
              component={ResetPasswordScreen}
              options={{ headerShown: false }}
            />
          </>
        )}
        </Stack.Navigator>
      </NavigationContainer>
    </View>
  );
};

const styles = StyleSheet.create({
  appContainer: {
    flex: 1,
  },
  connectivityBannerOffline: {
    backgroundColor: "#92400e",
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  connectivityBannerSyncing: {
    backgroundColor: "#0f766e",
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  connectivityBannerText: {
    color: "#f8fafc",
    fontSize: 12,
    fontWeight: "700",
    textAlign: "center",
  },
  installBanner: {
    backgroundColor: "#eff6ff",
    borderBottomWidth: 1,
    borderBottomColor: "#bfdbfe",
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  installBannerText: {
    color: "#1e3a8a",
    fontSize: 12,
    fontWeight: "700",
    textAlign: "center",
  },
  installBannerActions: {
    marginTop: 8,
    flexDirection: "row",
    justifyContent: "center",
    gap: 8,
  },
  installBannerPrimaryButton: {
    backgroundColor: "#1d4ed8",
    borderRadius: 999,
    paddingHorizontal: 12,
    paddingVertical: 6,
  },
  installBannerPrimaryText: {
    color: "#ffffff",
    fontSize: 12,
    fontWeight: "800",
  },
  installBannerSecondaryButton: {
    backgroundColor: "#dbeafe",
    borderRadius: 999,
    paddingHorizontal: 12,
    paddingVertical: 6,
  },
  installBannerSecondaryText: {
    color: "#1e40af",
    fontSize: 12,
    fontWeight: "700",
  },
});

export default AppWrapper;
